import _ from 'lodash';

export const hitAreaStyles = {
  position: 'absolute',
  top: '2px',
  left: '2px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px',
  cursor: 'pointer',
  zIndex: 1,
};

export const inlineHitAreaStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px',
  cursor: 'pointer',
};

export const dotContainerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
};

export const getDotColorStyles = (color, index, isActive) => ({
  width: '7px',
  height: '7px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: isActive ? color : 'transparent',
  border: '1.5px solid',
  borderColor: color,
  marginLeft: index > 0 ? '-3px' : 0,
  ...(isActive && {
    animation: 'presencePulse 2s ease-in-out infinite',
    '@keyframes presencePulse': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0.5 },
    },
  }),
});

export const tooltipPopperProps = {
  disablePortal: false,
  sx: { zIndex: 10000 },
};

export const tooltipSlotProps = {
  popper: tooltipPopperProps,
  tooltip: {
    sx: {
      padding: '8px 12px',
      backgroundColor: ({ palette }) => palette.background.paper,
      borderRadius: '8px',
      boxShadow: ({ palette }) => palette.shadow.m,
      zIndex: 10000,
    },
  },
};

export const tooltipListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const tooltipHeaderRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

const tooltipAvatarStyles = {
  height: '24px',
  width: '24px',
  fontSize: '1rem',
};

export const getTooltipDotAvatarStyles = colorSet => ({
  ...tooltipAvatarStyles,
  ...(!_.isNil(colorSet) && { backgroundColor: colorSet.bg, color: colorSet.fg }),
});

export const tooltipItemStyles = {
  fontSize: '1.2rem',
  color: ({ palette }) => palette.text.primary,
};

export const tooltipSectionStyles = {
  fontSize: '1.1rem',
  color: ({ palette }) => palette.text.secondary,
  marginTop: '2px',
};
